module.exports = __webpack_public_path__ + "static/media/dramaImg3.0954676e.jpg";